import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { customStyle } from 'helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

const years = _.range(1970, +moment().format('YYYY') + 1).sort((a, b) => b - a);

const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

function ConsolidationDetails({
  formData,
  setFormData,
  validateForm,
  inquireMachineryApplication,
  transactionCode,
  getMachineryTaxEffectivityPeriod,
  taxEffectivityPeriod,
  createRichTextEditor,
}) {
  const [machineryApplications, setMachineryApplications] = useState({
    machinery_application_id: [],
    machinery_applications: [],
  });

  const taxEffectivityYearOptions = useMemo(
    () =>
      taxEffectivityPeriod.map((item) => ({
        label: item?.year,
        value: item?.year,
      })),
    [taxEffectivityPeriod]
  );

  const registeredYearOptions = years.map((year) => ({
    label: year,
    value: year,
  }));

  const quarterOptions = useMemo(
    () =>
      taxEffectivityPeriod.find(
        (item) => item?.year === +formData?.tax_effectivity_year
      )?.quarter ?? []
  ).map(
    (item) => ({
      label: quarterList.find((qtr) => +qtr.value === +item)?.label,
      value: item,
    }),
    [taxEffectivityPeriod, formData?.tax_effectivity_year]
  );

  const handleOnChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleOnSearch = () => {
    const duplicateApplication =
      machineryApplications.machinery_applications.find(
        (item) => item?.tdn === formData?.tdn
      );
    if (duplicateApplication !== undefined) {
      Alert.error('TDN/PIN record already exist');
      return;
    }
    inquireMachineryApplication(
      { tdn: formData.tdn, rptax_transaction_code_id: transactionCode },
      (res) => {
        const idList = [...machineryApplications?.machinery_application_id];
        const applicationList = [
          ...machineryApplications?.machinery_applications,
        ];
        setMachineryApplications({
          machinery_application_id: [...idList, +res?.data?.id],
          machinery_applications: [
            ...applicationList,
            {
              tdn: res?.data?.attributes?.tdn,
              pin: res?.data?.attributes?.pin,
            },
          ],
        });
        setFormData({
          ...formData,
          tdn: '',
          machinery_application_id: [...idList, +res?.data?.id],
        });
      }
    );
  };

  const handleRemoveItem = (index) => {
    const updatedMachineryApplicationIds = [
      ...formData.machinery_application_id,
    ];
    updatedMachineryApplicationIds.splice(index, 1);
    const updatedMachineryApplications = [
      ...machineryApplications.machinery_applications,
    ];
    updatedMachineryApplications.splice(index, 1);

    setFormData({
      ...formData,
      machinery_application_id: updatedMachineryApplicationIds,
    });
    setMachineryApplications({
      machinery_application_id: updatedMachineryApplicationIds,
      machinery_applications: updatedMachineryApplications,
    });
  };

  useEffect(() => {
    if (
      formData?.machinery_application_id &&
      formData?.machinery_application_id.length > 0
    ) {
      getMachineryTaxEffectivityPeriod(+formData?.machinery_application_id[0], {
        rptax_transaction_code_id: transactionCode,
      });
    }
  }, [formData?.machinery_application_id, transactionCode]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <div className="row">
      <div className="col-6 form-group">
        <label htmlFor="last_name" className="form-label mb-0">
          TDN/ARP No.
          {validateForm.renderMessage('tdn')}
        </label>
        <div className="input-group col-12 mt-2" style={{ marginLeft: -15 }}>
          <InputMask
            className="form-control"
            mask="aa-99999-99999"
            alwaysShowMask
            type="text"
            name="tdn"
            onChange={handleOnChange}
            value={_.get(formData, 'tdn') ?? ''}
          />
          <div className="input-group-append">
            <button
              disabled={
                _.get(formData, 'tdn') === '__-_____-_____' ||
                _.get(formData, 'tdn') === ''
              }
              type="button"
              onClick={handleOnSearch}
              className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
            >
              <span className="icon">
                <i className="fa fa-lg fa-search" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="col-6 form-group" />
      <div className="col-12 form-group">
        <table
          className="table table-sm table-hover"
          style={{ minWidth: '250px' }}
        >
          <thead className="table-header">
            <tr>
              <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                ARP/TDN
              </th>
              <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                PIN
              </th>
              <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(machineryApplications?.machinery_applications) &&
              machineryApplications?.machinery_applications.map((item, id) => (
                <tr key={item.tdn}>
                  <td className="p-3">{item.tdn}</td>
                  <td className="p-3">{item.pin}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => handleRemoveItem(id)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="col-6 form-group pr-1">
        <label htmlFor="tax_effectivity_year" className="form-label mb-0">
          Tax Effectivity Year &nbsp;{' '}
          {validateForm.renderMessage('tax_effectivity_year')}
        </label>
        <Select
          options={taxEffectivityYearOptions}
          styles={customStyle}
          placeholder="Select Year"
          value={taxEffectivityYearOptions.find(
            (item) => item.value === _.get(formData, 'tax_effectivity_year')
          )}
          onChange={handleSelected('tax_effectivity_year')}
          isDisabled={_.isEmpty(formData?.machinery_application_id)}
        />
      </div>
      <div className="col-6 form-group pl-1">
        <label htmlFor="tax_effectivity_quarter" className="form-label mb-0">
          Tax Effectivity Quarter: &nbsp;{' '}
          {validateForm.renderMessage('tax_effectivity_quarter')}
        </label>
        <Select
          styles={customStyle}
          placeholder="Select Quarter"
          value={
            quarterOptions.filter(
              (item) =>
                `${item.value}` === _.get(formData, 'tax_effectivity_quarter')
            )[0]
          }
          options={quarterOptions}
          onChange={handleSelected('tax_effectivity_quarter')}
          isDisabled={
            formData?.tax_effectivity_year === '' ||
            formData?.tax_effectivity_year === undefined ||
            _.isEmpty(formData?.machinery_application_id)
          }
        />
      </div>
      <div className="col-6 form-group pr-1">
        <label htmlFor="registered" className="form-label mb-0">
          Registered &nbsp; {validateForm.renderMessage('registered')}
        </label>
        <Select
          options={registeredYearOptions}
          styles={customStyle}
          placeholder="Select Year"
          value={registeredYearOptions.find(
            (item) => item.value === _.get(formData, 'registered')
          )}
          onChange={handleSelected('registered')}
          isDisabled={_.isEmpty(formData?.machinery_application_id)}
        />
      </div>
      <div className="col-12 form-group">
        {createRichTextEditor(
          { key: 'memoranda', label: 'Memoranda:' },
          { minLength: 3, required: true }
        )}
      </div>
    </div>
  );
}

ConsolidationDetails.defaultProps = {};

ConsolidationDetails.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  transactionCode: PropTypes.string.isRequired,
  inquireMachineryApplication: PropTypes.instanceOf(Function).isRequired,
  getMachineryTaxEffectivityPeriod: PropTypes.instanceOf(Function).isRequired,
  taxEffectivityPeriod: PropTypes.instanceOf(Array).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxEffectivityPeriod:
    _.get(api, `${c.GET_MACHINERY_TAX_EFFECTIVITY_PERIOD}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICTS_LIST}.list`) || [],
  ownerList: _.get(api, `${c.GET_MACHINERY_OWNER}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ConsolidationDetails);
